import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import DocumentosController from '@/assets/ts/controller/DocumentosController';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';

import NovaSolicitacaoController from '@/assets/ts/controller/NovaSolicitacaoController';
import AdmissaoController from '@/assets/ts/controller/AdmissaoController';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';



@Component({
  name: 'NovoBeneficioPopup',
  components: {
    TkForm,
  },
})
class NovoBeneficioPopup extends Vue {
  // #region [ PROPS ]
  @Prop({ default: false })
  private readonly loading: boolean;

  @Prop({ default: undefined })
  private readonly overrideSaveAction: (internalRow: any) => any;

  @Prop({ default: null })
  private readonly row: any;

  @Prop({ default: false })
  private readonly value: boolean;
  // #endregion

  // #region [ EVENTS ]
  @Emit('after-save')
  private emitAfterSave() {}

  @Emit('input')
  private emitInput(value: boolean) {}
  // #endregion

  // #region [ DATA ]
  private readonly defaultRow: any = {
    QTBENEFICIO: 1,
    IDATIVO: 'S',
  };

  private internalValue = false;

  private internalLoading = {
    beneficios: false,
    integracoes: false,
  };

  private internalRow: any = {};

  private fieldsData = {
    beneficios: [],
    integracoes: [],
  };
  // #endregion

  // #region [ COMPUTED ]
  private get isLoading(): boolean {
    const loadingValues = Object.values(this.internalLoading);
    const internalLoading = Util.oneTrue(...loadingValues);

    const loading = internalLoading || this.loading;

    return loading;
  }

  private get fields(): Field[] {
    const fields: Field[] = [
      {
        name: 'NRBENEFICIOM',
        label: 'Benefício',
        type: 'autocomplete',
        size: 12,
        required: true,
        descriptionField: 'DSBENEFICIO',
        valueField: 'NRBENEFICIOM',
        items: this.fieldsData.beneficios,
        outData: {
          NRBENEFICIOM: 'NRBENEFICIOM',
          DSBENEFICIO: 'DSBENEFICIO',
        },
      },
      {
        name: 'NRINSCBENEFICIARIO',
        label: 'Número de Inscrição',
        type: 'text',
        size: 10,
      },
      {
        name: 'IDATIVO',
        label: 'Ativo',
        type: 'checkbox',
        size: 2,
        valueToTrue: 'S',
        valueToFalse: 'N',
      },
      {
        name: 'DTINSCBENEFICIARIO',
        label: 'Data de Inscrição',
        type: 'date',
        size: 4,
        required: true,
      },
      {
        name: 'DTCANCBENEFICIARIO',
        label: 'Data de Cancelamento',
        type: 'date',
        size: 4,
      },
      {
        name: 'QTBENEFICIO',
        label: 'Quantidade do Benefício',
        type: 'number',
        size: 4,
        required: true,
      },
      {
        name: 'NRINTEGTRANSPM',
        label: 'Integração Eletrônica',
        type: 'autocomplete',
        size: 12,
        descriptionField: 'CDINTEGTRANSP',
        valueField: 'NRINTEGTRANSPM',
        items: this.fieldsData.integracoes,
      },
      {
        name: 'DSOBSBENEFICIARIO',
        label: 'Observação',
        type: 'textarea',
        size: 12,
        rows: 2,
      },
    ];

    return fields;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.loadFields();
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.internalValue) {
      if (this.row === null) {
        this.setDefaultRow();
      } else {
        this.internalRow = Util.deepCopy(this.row);
      }
    }
  }
  // #endregion

  // #region [ METHODS ]
  private closeDialog() {
    this.internalValue = false;
    this.emitInput(this.internalValue);
  }

  private onSave() {
    if (!this.validate()) {
      return;
    }

    if (this.overrideSaveAction) {
      this.overrideSaveAction(this.internalRow);
    } else {
      this.save();
    }
  }

  private async save() {
    //
  }

  private loadFields() {
    this.loadBeneficios();
    this.loadIntegracoes();
  }

  private async loadBeneficios() {
    this.internalLoading.beneficios = true;

    try {
      this.fieldsData.beneficios =
        await AdmissaoController.getBeneficio(false);
    } finally {
      this.internalLoading.beneficios = false;
    }
  }

  private async loadIntegracoes() {
    this.internalLoading.integracoes = true;

    try {
      this.fieldsData.integracoes =
        await NovaSolicitacaoController.getIntegtransp(false);
    } finally {
      this.internalLoading.integracoes = false;
    }
  }

  private setDefaultRow() {
    this.internalRow = Util.deepCopy(this.defaultRow);
  }

  private validate(): boolean {
    if (!this.validateFields()) {
      return false;
    }

    if (!DateUtil.validateDates(this.internalRow.DTINICIO, this.internalRow.DTIFIM)) {
      return false;
    }

    if (!this.validateQuantidade()) {
      return false;
    }

    return true;
  }

  private validateQuantidade(): boolean {
    const quantidade: number = this.internalRow.QTBENEFICIO;

    if (quantidade <= 0) {
      const message = 'A quantidade deve ser maior que 0!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      return false;
    }

    return true;
  }

  private validateFields(): boolean {
    const isValid: boolean = (this.$refs.form as any).validate(true);

    if (!isValid) {
      const message = 'Preencha todos os campos obrigatórios!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      return;
    }

    return isValid;
  }
  // #endregion
}

export default NovoBeneficioPopup;
